import {useI18n} from '@udemy/i18n';
import {Badge} from '@udemy/react-messaging-components';
import {Tooltip} from '@udemy/react-popup-components';

import {CapitalizeFirstLetter} from '../../features/payout-report/common';
import {
    PayoutMethod,
    PayoutStatus,
    PayoutStatusLabel,
} from '../../features/payout-report/constants';
import styles from './payout-status-badge.module.less';

export const PayoutStatusBadge = (props: {status: string; payoutMethod: string}) => {
    const {gettext} = useI18n();

    const getBadge = () => {
        switch (props.status.toUpperCase()) {
            case PayoutStatus.FAILED:
            case PayoutStatus.CANCELLED:
                return (
                    <Badge className={styles['error']}>
                        {CapitalizeFirstLetter(PayoutStatus.FAILED)}
                    </Badge>
                );
            case PayoutStatus.PROCESSING:
            case PayoutStatus.PENDING:
                return (
                    <Badge className={styles['pending']}>
                        {CapitalizeFirstLetter(PayoutStatus.PROCESSING)}
                    </Badge>
                );
            case PayoutStatus.QUEUING:
                return (
                    <Badge className={styles['pending']}>
                        {CapitalizeFirstLetter(PayoutStatus.QUEUING)}
                    </Badge>
                );
            case PayoutStatus.READY_TO_PAY:
                return (
                    <Badge className={styles['pending']}>
                        {CapitalizeFirstLetter(PayoutStatus.READY_TO_PAY)}
                    </Badge>
                );
            case PayoutStatus.SUCCESS:
                return (
                    <Badge className={styles['success']}>
                        {CapitalizeFirstLetter(PayoutStatus.SUCCESS)}
                    </Badge>
                );
            case PayoutStatus.PARTIALLY_SUCCESS:
                return (
                    <Badge className={styles['warn']}>
                        {CapitalizeFirstLetter(PayoutStatus.PARTIALLY_SUCCESS)}
                    </Badge>
                );
            case PayoutStatus.BLOCKED:
                return (
                    <Badge className={styles['error']}>
                        {CapitalizeFirstLetter(PayoutStatus.BLOCKED)}
                    </Badge>
                );
            case PayoutStatus.UNPAID:
                return (
                    <Badge className={styles['unpaid']}>
                        {CapitalizeFirstLetter(PayoutStatus.UNPAID)}
                    </Badge>
                );
            case PayoutStatus.INITIAL:
                return props.payoutMethod == PayoutMethod.WIRE ||
                    props.payoutMethod == PayoutMethod.CHEQUE ? (
                    <Badge className={styles['pending']}>
                        {CapitalizeFirstLetter(PayoutStatus.UNDEFINED)}
                    </Badge>
                ) : (
                    <Badge className={styles['pending']}>
                        {CapitalizeFirstLetter(PayoutStatus.INITIAL)}
                    </Badge>
                );
            case PayoutStatus.DERECOGNIZED:
                return (
                    <Badge className={styles['error']}>
                        {CapitalizeFirstLetter(PayoutStatus.DERECOGNIZED)}
                    </Badge>
                );
        }
        return (
            <Badge className={styles['pending']}>
                {CapitalizeFirstLetter(PayoutStatus.UNDEFINED)}
            </Badge>
        );
    };

    const getLabel = () => {
        switch (props.status.toUpperCase()) {
            case PayoutStatus.FAILED:
            case PayoutStatus.CANCELLED:
                return PayoutStatusLabel.FAILED_LABEL;

            case PayoutStatus.PROCESSING:
            case PayoutStatus.PENDING:
                return PayoutStatusLabel.PROCESSING_LABEL;

            case PayoutStatus.QUEUING:
                return PayoutStatusLabel.QUEUING_LABEL;

            case PayoutStatus.READY_TO_PAY:
                return PayoutStatusLabel.READYTOPAY_LABEL;

            case PayoutStatus.SUCCESS:
                return PayoutStatusLabel.SUCCESS_LABEL;

            case PayoutStatus.PARTIALLY_SUCCESS:
                return PayoutStatusLabel.PARTIALLY_SUCCESS_LABEL;

            case PayoutStatus.BLOCKED:
                return PayoutStatusLabel.BLOCKED_LABEL;

            case PayoutStatus.DERECOGNIZED:
                return PayoutStatusLabel.DERECOGNIZED_LABEL;

            case PayoutStatus.UNPAID:
                return PayoutStatusLabel.UNPAID_LABEL;

            case PayoutStatus.INITIAL:
                return props.payoutMethod == PayoutMethod.WIRE ||
                    props.payoutMethod == PayoutMethod.CHEQUE
                    ? PayoutStatusLabel.UNDEFINED_LABEL
                    : PayoutStatusLabel.PROCESSING_LABEL;
        }
        return PayoutStatusLabel.UNDEFINED_LABEL;
    };

    return (
        <Tooltip placement={'right'} trigger={getBadge()}>
            {/* eslint-disable-next-line @udemy/no-variable-string */}
            {gettext(getLabel())}
        </Tooltip>
    );
};
